var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 5.83398C11.7279 5.83398 12.7453 6.25541 13.4954 7.00556C14.2456 7.7557 14.667 8.77312 14.667 9.83398V14.5007H12.0003V9.83398C12.0003 9.48036 11.8598 9.14122 11.6098 8.89118C11.3598 8.64113 11.0206 8.50065 10.667 8.50065C10.3134 8.50065 9.97423 8.64113 9.72418 8.89118C9.47413 9.14122 9.33366 9.48036 9.33366 9.83398V14.5007H6.66699V9.83398C6.66699 8.77312 7.08842 7.7557 7.83857 7.00556C8.58871 6.25541 9.60613 5.83398 10.667 5.83398Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99967 6.5H1.33301V14.5H3.99967V6.5Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 4.50065C3.40272 4.50065 3.99967 3.9037 3.99967 3.16732C3.99967 2.43094 3.40272 1.83398 2.66634 1.83398C1.92996 1.83398 1.33301 2.43094 1.33301 3.16732C1.33301 3.9037 1.92996 4.50065 2.66634 4.50065Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedln);
export default __webpack_public_path__ + "static/media/linkedln.6f54f306c589cc4778e40168cbea14d2.svg";
export { ForwardRef as ReactComponent };